package one.healthium.insights.ui.insights.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.theme.AppTheme

@Composable
internal fun EmptyState(
    modifier: Modifier = Modifier,
    title: String,
    message: String,
    buttonText: String,
    onClick: () -> Unit
) {
    Column(
        modifier = modifier.padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Spacer(Modifier.weight(0.7f))
        Text(
            text = title,
            style = AppTheme.textStyles.secondary_30_500,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(16.dp))
        Text(
            text = message,
            style = AppTheme.textStyles.secondary_18_400,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(36.dp))
        AppButton(
            minHeight = 36.dp,
            onClick = onClick,
        ) {
            Text(buttonText, style = AppTheme.textStyles.secondary_14_500)
        }
        Spacer(Modifier.weight(1f))
    }
}

@Composable
@Preview(showBackground = true)
private fun EmptyStatePreview() {
    AppTheme {
        EmptyState(
            modifier = Modifier.fillMaxSize(),
            title = "Nothing to show… yet",
            message = "Discover and favorite insights to build your personal list — they’ll appear here once added.",
            buttonText = "Browse Articles",
            onClick = {},
        )
    }
}